module.exports = "app.service(\"ExternalUnit\",[\"Resty\",function(Resty){return Resty(\"external_units\");}]);"